export enum ScanResultType {
    LineItemCurrentStop = 0,
    LineItemDifferentStop = 1,
    LineItemDifferentLoad = 2,
    LPCurrentStop = 3,
    LPDifferentStop = 4,
    LPDifferentLoad = 5,
    BarcodeNotFound = 6,
    ReturnItemCurrentStop = 7,
    MultipleScannedValues = 8
}

export enum ScanResultValueType {
    OrderItem = 0,
    LicensePlate = 1,
    ReturnItem = 2,
    BarcodeNotFound = 3
}

